
import React from 'react';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import {
  Home,
  Info,
  ShoppingBag,
  Grid,
  Phone,
  Box,
  MessageSquare
} from 'react-feather';
import useDeviceDetection from '../../pages/useDeviceDetection';
// Define the brand color palette
const theme = {
  primaryRed: '#D91C1C',
  deepMaroon: '#6B1111',
  white: '#FFFFFF',
  darkBrown: '#1A0808'
};

const BottomNavigation = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const { isMobile } = useDeviceDetection();

  const isActive = (path) => {
    return location.pathname === path;
  };

  const handleShowroomClick = (e) => {
    e.preventDefault();
    navigate('/showroom');
  };

  return (
    <NavContainer>
      <NavGradientBorder />
      <NavItem to="/" active={isActive('/')}>
        <IconWrapper active={isActive('/')}>
          <Home size={18} />
        </IconWrapper>
        <NavText active={isActive('/')}>Home</NavText>
        {isActive('/') && <ActiveIndicator />}
      </NavItem>

      <NavItem to="/about" active={isActive('/about')}>
        <IconWrapper active={isActive('/about')}>
          <Info size={18} />
        </IconWrapper>
        <NavText active={isActive('/about')}>About</NavText>
        {isActive('/about') && <ActiveIndicator />}
      </NavItem>

      <NavItem to="/products" active={isActive('/products')}>
        <IconWrapper active={isActive('/products')}>
          <ShoppingBag size={18} />
        </IconWrapper>
        <NavText active={isActive('/products')}>Products</NavText>
        {isActive('/products') && <ActiveIndicator />}
      </NavItem>

      {/* Custom showroom navigation with device detection */}
      <NavItem
        to="#"
        onClick={handleShowroomClick}
        active={isActive('/showroom')}
      >
        <IconWrapper active={isActive('/showroom')}>
          <Box size={18} />
        </IconWrapper>
        <NavText active={isActive('/showroom')}>Showroom</NavText>
        {isActive('/showroom') && <ActiveIndicator />}
      </NavItem>

      <NavItem to="/gallery" active={isActive('/gallery')}>
        <IconWrapper active={isActive('/gallery')}>
          <Grid size={18} />
        </IconWrapper>
        <NavText active={isActive('/gallery')}>Gallery</NavText>
        {isActive('/gallery') && <ActiveIndicator />}
      </NavItem>

      <NavItem to="/contact" active={isActive('/contact')}>
        <IconWrapper active={isActive('/contact')}>
          <Phone size={18} />
        </IconWrapper>
        <NavText active={isActive('/contact')}>Contact</NavText>
        {isActive('/contact') && <ActiveIndicator />}
      </NavItem>
    </NavContainer>
  );
};

// Styling components remain unchanged
const NavContainer = styled.nav`
  position: fixed;
  bottom: 16px;
  left: 50%;
  transform: translateX(-50%);
  width: 94%;
  max-width: 520px;
  height: 65px;
  background-color: ${theme.white};
  display: flex;
  justify-content: space-around;
  align-items: center;
  box-shadow: 0 4px 20px rgba(26, 8, 8, 0.18);
  z-index: 1000;
  border-radius: 16px;
  
  @media (min-width: 768px) {
    width: 520px;
  }
`;

const NavGradientBorder = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 2px;
  background: linear-gradient(to right, ${theme.deepMaroon}, ${theme.primaryRed}, ${theme.deepMaroon});
  border-radius: 16px 16px 0 0;
`;

const IconWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 38px;
  height: 38px;
  border-radius: 10px;
  transition: all 0.3s ease;
  background-color: ${props => props.active ? `${theme.deepMaroon}10` : 'transparent'};
  color: ${props => props.active ? theme.deepMaroon : `${theme.darkBrown}99`};
  margin-bottom: 2px;
`;

const NavItem = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 5px 0;
  flex: 1;
  text-decoration: none;
  position: relative;
  transition: all 0.3s ease;
  
  &:hover ${IconWrapper} {
    background-color: ${props => props.active ? `${theme.deepMaroon}15` : `${theme.darkBrown}10`};
    color: ${props => props.active ? theme.deepMaroon : theme.primaryRed};
  }
`;

const NavText = styled.span`
  font-size: 0.7rem;
  font-weight: ${props => props.active ? '500' : 'normal'};
  color: ${props => props.active ? theme.deepMaroon : `${theme.darkBrown}99`};
  transition: color 0.3s ease;
  margin-top: 2px;
`;

const ActiveIndicator = styled.div`
  position: absolute;
  top: -2px;
  left: 50%;
  transform: translateX(-50%);
  width: 25px;
  height: 2px;
  background: linear-gradient(to right, ${theme.primaryRed}, ${theme.deepMaroon});
  border-radius: 1px;
`;

export default BottomNavigation;